var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-row",
        { staticClass: "align-items-center" },
        [
          _c("b-col", { attrs: { md: "8" } }),
          _c("b-col", { attrs: { md: "4" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end align-items-center" },
              [
                _c(
                  "b-form-checkbox",
                  {
                    staticClass: "ml-1",
                    attrs: { name: "check-button", switch: "", inline: "" },
                    model: {
                      value: _vm.displayKanban,
                      callback: function ($$v) {
                        _vm.displayKanban = $$v
                      },
                      expression: "displayKanban",
                    },
                  },
                  [_vm._v(" Kanban ")]
                ),
                _c(
                  "b-modal",
                  {
                    ref: "addProjectModal",
                    attrs: {
                      id: "modal-add-task",
                      "ok-only": "",
                      "ok-title": "Add",
                      centered: "",
                      size: "lg",
                      title: "Add Task",
                      "hide-footer": true,
                    },
                  },
                  [
                    _c("AddTask", {
                      attrs: { task: _vm.defaultTask },
                      on: { taskAdded: _vm.closeAddProjectModal },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.modal-add-task",
                        modifiers: { "modal-add-task": true },
                      },
                    ],
                    attrs: { variant: "primary" },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "PlusIcon" },
                    }),
                    _vm._v(" Add Task "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "editProjectModal",
          attrs: {
            id: "modal-edit-task",
            "ok-only": "",
            "ok-title": "Edit",
            centered: "",
            size: "lg",
            title: "Edit Task",
            "hide-footer": true,
          },
        },
        [
          _c("EditTask", {
            attrs: { task: _vm.currentTask },
            on: { taskUpdated: _vm.closeEditProjectModal },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "editProjectModal",
          attrs: {
            id: "modal-view-task",
            "ok-only": "",
            "ok-title": "View",
            centered: "",
            size: "lg",
            title: "View Task",
            "hide-footer": true,
          },
        },
        [
          _c("EditTask", {
            attrs: { task: _vm.currentTask, isView: true },
            on: { taskUpdated: _vm.closeEditProjectModal },
          }),
        ],
        1
      ),
      _vm.tasks.length === 0 && !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c(
                        "b-card",
                        [
                          _c("b-card-body", { staticClass: "text-center" }, [
                            _c("h2", [_vm._v("No tasks available")]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "d-block" },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-end my-1" },
                [
                  _c("b-col", {
                    staticClass:
                      "d-flex justify-content-end align-items-center",
                    attrs: { md: "6" },
                  }),
                ],
                1
              ),
              !_vm.displayKanban
                ? _c(
                    "b-row",
                    { staticClass: "justify-content-between table-row" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                        [
                          _c(
                            "b-form-group",
                            { staticClass: "mb-0" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-inline-block text-sm-left mr-50",
                                },
                                [_vm._v("Per page")]
                              ),
                              _c("b-form-select", {
                                staticClass: "w-50",
                                attrs: {
                                  id: "perPageSelect",
                                  size: "sm",
                                  options: _vm.pageOptions,
                                },
                                model: {
                                  value: _vm.perPage,
                                  callback: function ($$v) {
                                    _vm.perPage = $$v
                                  },
                                  expression: "perPage",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex justify-content-end mb-2",
                          staticStyle: { position: "relative", "z-index": "1" },
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-danger", size: "sm" },
                              on: { click: _vm.clearFilters },
                            },
                            [_vm._v(" Clear Filters ")]
                          ),
                        ],
                        1
                      ),
                      !_vm.loading
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.selectedOption === "task",
                                      expression: "selectedOption === 'task'",
                                    },
                                  ],
                                  staticClass: "table-task",
                                },
                                [
                                  _c("b-table", {
                                    attrs: {
                                      striped: "",
                                      hover: "",
                                      responsive: "",
                                      items: _vm.filteredTasks,
                                      fields: _vm.fields,
                                      "per-page": _vm.perPage,
                                      "current-page": _vm.currentPage,
                                      filter: _vm.filter,
                                    },
                                    on: { filtered: _vm.onFiltered },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "head(title)",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _c("span", [_vm._v("Title")]),
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "Filter by Title",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      input: _vm.applyFilters,
                                                    },
                                                    model: {
                                                      value: _vm.filters.title,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filters,
                                                          "title",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filters.title",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "head(assigneeName)",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Assignee(s)"),
                                                  ]),
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "Filter by Assignee",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      input: _vm.applyFilters,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filters
                                                          .assigneeName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filters,
                                                          "assigneeName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filters.assigneeName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "head(priority)",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Priority"),
                                                  ]),
                                                  _c("b-form-select", {
                                                    attrs: {
                                                      options:
                                                        _vm.priorityOptions,
                                                      placeholder:
                                                        "Select Priority",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      change: _vm.applyFilters,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filters.priority,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filters,
                                                          "priority",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filters.priority",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "head(status)",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Status"),
                                                  ]),
                                                  _c("b-form-select", {
                                                    attrs: {
                                                      options:
                                                        _vm.statusOptions,
                                                      placeholder:
                                                        "Select Status",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      change: _vm.applyFilters,
                                                    },
                                                    model: {
                                                      value: _vm.filters.status,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filters,
                                                          "status",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filters.status",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "head(startDate)",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Start Date"),
                                                  ]),
                                                  _c("DatePicker", {
                                                    staticStyle: {
                                                      "max-width": "180px",
                                                    },
                                                    attrs: {
                                                      range: "",
                                                      format: "YYYY-MM-DD",
                                                      placeholder:
                                                        "Select date range",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      change: _vm.applyFilters,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filters
                                                          .startDateRange,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filters,
                                                          "startDateRange",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filters.startDateRange",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "head(endDate)",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("End Date"),
                                                  ]),
                                                  _c("DatePicker", {
                                                    staticStyle: {
                                                      "max-width": "180px",
                                                    },
                                                    attrs: {
                                                      range: "",
                                                      format: "YYYY-MM-DD",
                                                      placeholder:
                                                        "Select date range",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      change: _vm.applyFilters,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filters
                                                          .endDateRange,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filters,
                                                          "endDateRange",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filters.endDateRange",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "head(milestoneName)",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Milestone"),
                                                  ]),
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "Filter by Milestone",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      input: _vm.applyFilters,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.filters
                                                          .milestoneName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filters,
                                                          "milestoneName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filters.milestoneName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(status)",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "b-badge",
                                                {
                                                  attrs: {
                                                    variant:
                                                      _vm.statusMap[
                                                        data.item.status
                                                      ].variant,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.statusMap[
                                                          data.item.status
                                                        ].text
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(milestoneName)",
                                          fn: function (data) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    data.item.milestonesName ||
                                                      "N/A"
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(startDate)",
                                          fn: function (data) {
                                            return [
                                              _vm.formatStartDate(data.item)
                                                .isOverdue &&
                                              _vm.formatStartDate(data.item)
                                                .isCompleted === false
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      attrs: {
                                                        variant: "danger",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatStartDate(
                                                              data.item
                                                            ).formattedDate
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm.formatStartDate(data.item)
                                                    .isOverdue &&
                                                  _vm.formatStartDate(data.item)
                                                    .isCompleted === true
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      attrs: {
                                                        variant: "success",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatStartDate(
                                                              data.item
                                                            ).formattedDate
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.formatStartDate(
                                                            data.item
                                                          ).formattedDate
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(endDate)",
                                          fn: function (data) {
                                            return [
                                              _vm.formatEndDate(data.item)
                                                .isOverdue &&
                                              _vm.formatEndDate(data.item)
                                                .isCompleted === false
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      attrs: {
                                                        variant: "danger",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatEndDate(
                                                              data.item
                                                            ).formattedDate
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm.formatEndDate(data.item)
                                                    .isOverdue &&
                                                  _vm.formatEndDate(data.item)
                                                    .isCompleted === true
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      attrs: {
                                                        variant: "success",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatEndDate(
                                                              data.item
                                                            ).formattedDate
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.formatEndDate(
                                                            data.item
                                                          ).formattedDate
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(priority)",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "b-badge",
                                                {
                                                  attrs: {
                                                    variant:
                                                      _vm.priorityMap[
                                                        data.item.priority
                                                      ].variant,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.priorityMap[
                                                          data.item.priority
                                                        ].text
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(actions)",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "b-dropdown",
                                                {
                                                  staticClass: "m-1",
                                                  attrs: {
                                                    variant: "link",
                                                    "toggle-class": "p-0",
                                                    "no-caret": "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "button-content",
                                                        fn: function () {
                                                          return [
                                                            _c("feather-icon", {
                                                              staticClass:
                                                                "align-middle text-body",
                                                              attrs: {
                                                                icon: "MoreVerticalIcon",
                                                                size: "16",
                                                              },
                                                            }),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  data.item.status !==
                                                  "COMPLETED"
                                                    ? _c(
                                                        "b-dropdown-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-modal",
                                                              rawName:
                                                                "v-b-modal.modal-edit-task",
                                                              modifiers: {
                                                                "modal-edit-task": true,
                                                              },
                                                            },
                                                          ],
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.EditTask(
                                                                data.item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "EditIcon",
                                                            },
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "align-middle ml-50",
                                                            },
                                                            [_vm._v("Edit")]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  data.item.status ===
                                                  "COMPLETED"
                                                    ? _c(
                                                        "b-dropdown-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-modal",
                                                              rawName:
                                                                "v-b-modal.modal-view-task",
                                                              modifiers: {
                                                                "modal-view-task": true,
                                                              },
                                                            },
                                                          ],
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.EditTask(
                                                                data.item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "EditIcon",
                                                            },
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "align-middle ml-50",
                                                            },
                                                            [_vm._v("View")]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  data.item.status ===
                                                  "NOTSTARTED"
                                                    ? _c(
                                                        "b-dropdown-item",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteTask(
                                                                data.item.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "TrashIcon",
                                                            },
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "align-middle ml-50",
                                                            },
                                                            [_vm._v("Delete")]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "b-dropdown-item",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          path:
                                                            "/projectmanagement/subtasks-list/" +
                                                            _vm.id +
                                                            "/" +
                                                            data.item.id,
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("feather-icon", {
                                                        attrs: {
                                                          icon: "EyeIcon",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "align-middle ml-50",
                                                        },
                                                        [_vm._v("Sub Tasks")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-dropdown-item",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewTaskDocument(
                                                            data.item.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("feather-icon", {
                                                        attrs: {
                                                          icon: "PaperclipIcon",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "align-middle ml-50",
                                                        },
                                                        [_vm._v("Documents")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-dropdown-item",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-modal",
                                                          rawName:
                                                            "v-b-modal.modal-edit",
                                                          modifiers: {
                                                            "modal-edit": true,
                                                          },
                                                        },
                                                      ],
                                                      attrs: {
                                                        to: _vm.addtimesheet(
                                                          data.item.id,
                                                          data.item.projectId
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("feather-icon", {
                                                        staticClass: "mr-50",
                                                        attrs: {
                                                          icon: "ClockIcon",
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v("Time sheet"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3883886710
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-modal",
                                {
                                  ref: "modal-view-document",
                                  attrs: {
                                    id: "modal-view-document",
                                    "ok-only": "",
                                    "ok-title": "View",
                                    centered: "",
                                    size: "lg",
                                    title: "View Documents",
                                    "hide-footer": true,
                                  },
                                },
                                [
                                  _c("DocumentUpload", {
                                    attrs: {
                                      documentDetails: _vm.documentDetails,
                                    },
                                    on: {
                                      deleteFile: _vm.deleteFile,
                                      downloadFile: _vm.downloadFile,
                                      uploadFiles: _vm.uploadFiles,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center mb-1",
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", {
                                    staticStyle: {
                                      width: "3rem",
                                      height: "3rem",
                                    },
                                    attrs: {
                                      variant: "success",
                                      label: "Spinning",
                                      block: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          !_vm.loading
                            ? _c("b-pagination", {
                                staticClass: "my-0",
                                attrs: {
                                  "total-rows": _vm.totalRows,
                                  "per-page": _vm.perPage,
                                  align: "center",
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.currentPage,
                                  callback: function ($$v) {
                                    _vm.currentPage = $$v
                                  },
                                  expression: "currentPage",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-row",
                    { staticClass: "kanban-row" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [_c("TaskKanban", { attrs: { tasks: _vm.tasks } })],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }